import {createStore, combineReducers, applyMiddleware} from "redux";
import _ from "lodash";

import products from "../utils/products";
import {composeWithDevTools} from "redux-devtools-extension";

import {persistStore, persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage"; // defaults to localStorage for web
import expireIn from "./transform.expire.reducers";

//middlewares
import thunk from "redux-thunk";
import apiMiddleware from "./middlewares/api.middleware";

//reducers
import formReducer, {handleFormSucceeded} from "./reducers/form";
import fullPublicReducer from "./reducers/full.public";
import stepReducer from "./reducers/step";
import listReducer from "./reducers/lists";
import conversionReducer from "./reducers/conversion";
import searchReducer, {handleCopySucceeded} from "./reducers/search";
import changeTypeReducer, {
    handleChangeTypeSucceeded,
} from "./reducers/change.type";
import agentSearchActions from "./actions/agent/search";
import agentFormActions from "./actions/agent/form";
import agentChangeTypeActions from "./actions/agent/change.type";

import config from "../config";

const middlewares = [thunk, apiMiddleware];

//combine reducers
const getStepReducers = () => {
    let out = {};
    _.forEach(products, (v, k) => {
        out = {
            ...out,
            [`step_${k}`]: stepReducer(`step_${k}`),
        };
    });
    return out;
};

const getFullFormReducers = () => {
    let out = {};
    _.forEach(products, (v, k) => {
        out = {
            ...out,
            [k]: formReducer(k),
        };
    });
    return out;
};

const getFullPublicFormReducers = () => {
    let out = {};
    _.forEach(products, (v, k) => {
        out = {
            ...out,
            [`full_public_${k}`]: fullPublicReducer(`full_public_${k}`),
        };
    });
    return out;
};

const fullPublicReducers = getFullPublicFormReducers();
const stepReducers = getStepReducers();
const fullFormReducers = getFullFormReducers();
const combinedReducers = combineReducers({
    ...fullPublicReducers,
    ...fullFormReducers,
    ...stepReducers,
    search: searchReducer,
    changeType: changeTypeReducer,
    lists: listReducer,
    conversion: conversionReducer,
});

const mixedReducers = (state, action) => {
    switch (action.type) {
        case agentSearchActions.search_copy_succeeded().type: {
            return handleCopySucceeded(state, action);
        }
        case agentFormActions.form_succeeded().type: {
            return handleFormSucceeded(state, action);
        }
        case agentChangeTypeActions.change_type_succeeded().type: {
            return handleChangeTypeSucceeded(state, action);
        }
        default: {
            return state;
        }
    }
};

const rootReducers = (state, action) =>
    mixedReducers(combinedReducers(state, action), action);
const _transforms = () =>
    _.map(products, (v, k) =>
        expireIn(`step_${k}`, {
            expireSeconds: 60 * 60 * 24 * 7,
            autoExpire: true,
            defaultState: {},
        })
    );
const _whitelist = () => _.map(products, (v, k) => `step_${k}`);

const persistedReducers = persistReducer(
    {
        key: "iros-lead",
        storage,
        transforms: [..._transforms()],
        whitelist: [..._whitelist()],
    },
    rootReducers
);

function clearStorage() {
    const storageKey = "persist:iros-lead";
    const state = store.getState();
    let storage = JSON.parse(localStorage.getItem(storageKey));

    _.forEach(state, (v, reducer_key) => {
        if (
            reducer_key.includes("step_") &&
            config.states_finished.includes(state[reducer_key].lead_state)
        ) {
            store.dispatch({
                name: reducer_key,
                type: "STEP_RESET",
            });
            storage = Object.keys(storage)
                .filter((key) => key !== reducer_key)
                .reduce((res, key) => Object.assign(res, {[key]: storage[key]}), {});
        }
    });
    localStorage.setItem(storageKey, JSON.stringify(storage));
}

const store = createStore(
    persistedReducers,
    {},
    composeWithDevTools(applyMiddleware(...middlewares))
);
let persistor = persistStore(store);
export {store, persistor, clearStorage};
